import { RCAlertBox, buttonClassName } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import I18n from 'i18n-js';
import DocumentBrandIcon from '@reverbdotcom/cadence/icons/brand/document-orange.svg';

function TaxInformationNeededBanner() {
  return (
    <RCAlertBox
      type="info"
    >
      <div className="d-flex fx-align-center fx-justify-between">
        <div className="d-flex fx-align-center">
          <img
            style={{ width: '5rem' }}
            className='mr-2'
            src={DocumentBrandIcon}
            alt={I18n.t('discovery.taxProfile.banner.documentAlt')}
          />
          <div>
            <h2 className='weight-bold'>
              <Translate
                text="discovery.taxProfile.taxInformationNeededBanner.headline"
              />
            </h2>
            <span>
              <Translate
                text="discovery.taxProfile.taxInformationNeededBanner.informationNeeded"
              />
            </span>
          </div>
        </div>
        <CoreLink
          className={buttonClassName({ variant: 'primary' })}
          to="/my/selling/tax_id"
        >
          <Translate
            text="discovery.taxProfile.taxInformationNeededBanner.submitButtonText"
          />
        </CoreLink>
      </div>
    </RCAlertBox>
  );
}

export default TaxInformationNeededBanner;
